import { Checkbox, CheckboxProps } from '@mui/material';
import { useTheme } from '@mui/styles';

import { CheckBoxPartial } from '@/components/icons/CheckBoxPartial';

type TLooseCheckboxProps = CheckboxProps & {
  all: boolean;
};

export const Partial = Symbol('partial');

export const AllCheckbox = ({ all, ...props }: TLooseCheckboxProps) => {
  const { palette } = useTheme();

  if (all) {
    return <Checkbox {...props} />;
  }

  return (
    <Checkbox checkedIcon={<CheckBoxPartial dashColor={palette.custom.contrast[9]} />} {...props} />
  );
};
